import {
    GET_ALL_DETAILS_FOR_DISPATCH, GET_ALL_PO_ITEM_DETAILS, REQUEST_PO_DISPATCH_CLEARANCE, GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER, GET_PO_DETAILS_FOR_DISPATCH_MATERIAL,
    UPDATE_DOCUMENTID_FOR_DISPATCH_DOCUMENTS,
    GET_PO_DETAILS_FOR_DISPATCH_PO_HEADER_MATERIAL, GENERATE_DISPATCH_CLEARENCE,
    GET_GRN_PO_HEADER, GET_GRN_PO_LINE_ITEM, GET_DISPATCH_TEMPLATE_MASTER_DATA, GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH, GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_ICListing, GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH2, GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH3, GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH4, GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_COUNT_FOR_DISPATCH, GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_PO, GET_DISPATCH_TEMPLATE_DETAILS,
    GET_BILLINGSCHEDULE_DETAILS, POST_VENDOR_DETAILS,
    Waive_Off_Inspection,
    GET_DEFAULT_DISPATCH_TEMPLATE_DETAILS,
    GET_CUSTOMER_MASTER,
    POST_CUSTOMER_MASTER
} from '../type'


const initialState = {
    allOrderDetails: [],
    allPoItemDetails: [],
    requestPoDispatch: [],
    allOrderDetailsSupplier: [],
    getAllPoForDispatchMaterial: [],
    dispatchDocumentID: [],
    getAllPoForDispatchMaterialPOHeader: [],
    generateDispatchClearence: [],
    getGRNdata: [],
    getGRNliteItemdata: [],
    getdispatchtemplatemasterdata: [],
    getPOAndLineItemDetails: [],
    getDispatchTemplateDetails: [],
    getBillingScheduleDetails: [],
    postVendorDetails: [],
    WaiveOffInspection: [],
    defaultDispatchTemplateDetails: [],
    getCustomerMaster:[],
    postCustomerMaster:[],
}

export default function dispatchOrderDetailsReducer(state = initialState, action) {
    switch (action.type) {

        case GET_ALL_DETAILS_FOR_DISPATCH:
            return {
                ...state,
                allOrderDetails: action.payload,
                loading: false
            }

        case GET_ALL_PO_ITEM_DETAILS:
            return {
                ...state,
                allPoItemDetails: action.payload,
                loading: false
            }
        case REQUEST_PO_DISPATCH_CLEARANCE:
            return {
                ...state,
                requestPoDispatch: action.payload,
                loading: false
            }
        case GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER:
            return {
                ...state,
                allOrderDetailsSupplier: action.payload,
                loading: false
            }
        case GET_PO_DETAILS_FOR_DISPATCH_MATERIAL:
            return {
                ...state,
                getAllPoForDispatchMaterial: action.payload,
                loading: false
            }
        case UPDATE_DOCUMENTID_FOR_DISPATCH_DOCUMENTS:
            return {
                ...state,
                dispatchDocumentID: action.payload,
                loading: false
            }
        case GET_PO_DETAILS_FOR_DISPATCH_PO_HEADER_MATERIAL:
            return {
                ...state,
                getAllPoForDispatchMaterialPOHeader: action.payload,
                loading: false
            }
        case GENERATE_DISPATCH_CLEARENCE:
            return {
                ...state,
                generateDispatchClearence: action.payload,
                loading: false
            }
        case GET_GRN_PO_HEADER:
            return {
                ...state,
                getGRNdata: action.payload,
                loading: false
            }
        case GET_GRN_PO_LINE_ITEM:
            return {
                ...state,
                getGRNliteItemdata: action.payload,
                loading: false
            }
        case GET_DISPATCH_TEMPLATE_MASTER_DATA:
            return {
                ...state,
                getdispatchtemplatemasterdata: action.payload,
                loading: false
            }
        case GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH:
            return {
                ...state,
                getPOAndLineItemDetails: action.payload,
                loading: false
            }
        case GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_ICListing:
            return {
                ...state,
                getPOAndLineItemDetailsICListing: action.payload,
                loading: false
            }    
        case GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_PO:
            return {
                ...state,
                getPOAndLineItemListForDispatchonPONumber: action.payload,
                loading: false
            }    
        case GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH2:
            return {
                ...state,
                getPOAndLineItemListForDispatchForDCListing: action.payload,
                loading: false
            }
        case GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH3:
        return {
            ...state,
            getPOAndLineItemDetailsBillingScheduleDetails: action.payload,
            loading: false
        }    
        case GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH4:
            return {
                ...state,
                getPOAndLineItemDetailsInspectionDetails: action.payload,
                loading: false
            }
        case GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_COUNT_FOR_DISPATCH:
            return {
                ...state,
                getPOAndLineItemListForDispatchCount: action.payload,
                loading: false
            }    
        case GET_DISPATCH_TEMPLATE_DETAILS:
            return {
                ...state,
                getDispatchTemplateDetails: action.payload,
                loading: false
            }
        case GET_BILLINGSCHEDULE_DETAILS:
            return {
                ...state,
                getBillingScheduleDetails: action.payload,
                loading: false
            }
        case POST_VENDOR_DETAILS:
            return {
                ...state,
                postVendorDetails: action.payload,
                loading: false
            }
        case Waive_Off_Inspection:
            return {
                ...state,
                WaiveOffInspection: action.payload,
                loading: false
            }
        case GET_DEFAULT_DISPATCH_TEMPLATE_DETAILS:
            return {
                ...state,
                defaultDispatchTemplateDetails: action.payload,
                loading: false
            }
        case GET_CUSTOMER_MASTER:
            return {
                ...state,
                getCustomerMaster: action.payload,
                loading: false
            }
        case POST_CUSTOMER_MASTER:
            return {
                ...state,
                postCustomerMaster: action.payload,
                loading: false
            }
        default: return state
    }
}